export default __webpack_public_path__ + "static/media/KOS.c57ab68a.svg";